export const hasEventsForCurrentPeriod = (eventApiData: any): boolean => {
  const timeline = eventApiData?.event_timeline;
  if (!timeline || typeof timeline !== 'object') {
    return false;
  }

  return Object.values(timeline).some((monthData: any) => {
    const eventList = monthData?.event_list;
    if (!eventList || typeof eventList !== 'object') {
      return false;
    }

    return Object.values(eventList).some(
      (projectEvents: any) =>
        Array.isArray(projectEvents) && projectEvents.length > 0,
    );
  });
};

export const shouldDisableEventToggle = (
  eventApiData: any,
): boolean => {
  // No event API data means no available event payload.
  if (!eventApiData) {
    return true;
  }

  return !hasEventsForCurrentPeriod(eventApiData);
};
